export default {
  title: 'Varer',
  order_note: 'Ordrenote',
};
